import styled from "styled-components";
import { Button } from "antd";

// Brand mint button (SbButton buttonType="accent") — used for auth actions (sign in, send OTP,
// reset, …). Fill + hover + legible dark text all come from the theme (accentMint tokens).
export const AccentButtonStyled = styled(Button)`
  && {
    background: ${(p) => p.theme?.colors?.accentMint};
    border-color: ${(p) => p.theme?.colors?.accentMint};
    color: ${(p) => p.theme?.colors?.accentMintText};
    &:hover,
    &:focus {
      background: ${(p) => p.theme?.colors?.accentMintHover};
      border-color: ${(p) => p.theme?.colors?.accentMintHover};
    }
  }
`;
